import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#5865f2] mx-auto mb-4"></div>
      <p className="text-gray-300 text-lg font-medium">Loading...</p>
      <p className="text-gray-400 text-sm mt-2">Please wait while we prepare your experience</p>
    </div>
  );
};

export default LoadingSpinner;
